import { render, staticRenderFns } from "./ReContactMessangersTemplate.vue?vue&type=template&id=50145442&scoped=true"
import script from "./ReContactMessangersTemplate.vue?vue&type=script&lang=js"
export * from "./ReContactMessangersTemplate.vue?vue&type=script&lang=js"
import style0 from "./ReContactMessangersTemplate.vue?vue&type=style&index=0&id=50145442&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50145442",
  null
  
)

export default component.exports